export const getScoreStyle = (
	score: number,
	lowScore: number,
	highScore: number,
	themeCss: { [key: string]: string }
) => {
	if (score < 0) {
		return themeCss.noScore;
	}

	if (themeCss.lowScore && score < lowScore) {
		return themeCss.lowScore;
	}

	if (themeCss.midScore && score < highScore) {
		return themeCss.midScore;
	}

	if (themeCss.highScore && score >= highScore) {
		return themeCss.highScore;
	}

	return '';
};
